import React, { useEffect } from 'react';

const AppDownloadRedirectPage: React.FC = () => {
  useEffect(() => {
    document.title = '앱 다운로드 - 폰피쉬';
  }, []);

  useEffect(() => {
    // 사용자 에이전트 감지
    const userAgent = navigator.userAgent.toLowerCase();
    
    // iOS 디바이스 감지
    if (/iphone|ipad|ipod/.test(userAgent)) {
      // App Store로 리다이렉트
      window.location.href = 'https://apps.apple.com/us/app/ponpish-%ED%8F%BC%ED%94%BC%EC%89%AC/id6743611917';
    }
    // Android 디바이스 감지
    else if (/android/.test(userAgent)) {
      // Google Play Store로 리다이렉트
      window.location.href = 'https://play.google.com/store/apps/details?id=com.chaenggigo.ponpish';
    }
    // 기타 디바이스 (데스크톱 등)
    else {
      // 웹사이트로 리다이렉트
      window.location.href = 'https://ponpish.co.kr/';
    }
  }, []);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="max-w-sm mx-auto text-center px-6">
        {/* 로딩 스피너 */}
        <div className="mb-8">
          <div className="animate-spin rounded-full h-12 w-12 border-2 border-gray-300 border-t-black mx-auto"></div>
        </div>
        
        <h1 className="text-xl font-medium text-gray-900 mb-2">
          앱 다운로드 중...
        </h1>
        
        <p className="text-gray-500 text-sm mb-8">
          잠시만 기다려주세요
        </p>
        
        {/* 수동 다운로드 링크 */}
        <div className="space-y-3">
          <p className="text-xs text-gray-400 mb-4">
            자동 이동이 되지 않으시나요?
          </p>
          
          <div className="space-y-2">
            <a
              href="https://apps.apple.com/us/app/ponpish-%ED%8F%BC%ED%94%BC%EC%89%AC/id6743611917"
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full px-4 py-3 bg-black text-white rounded-lg hover:bg-gray-800 transition-colors text-sm font-medium"
            >
              App Store에서 다운로드
            </a>
            
            <a
              href="https://play.google.com/store/apps/details?id=com.chaenggigo.ponpish"
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full px-4 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors text-sm font-medium"
            >
              Google Play에서 다운로드
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppDownloadRedirectPage;
